export default __webpack_public_path__ + "static/media/service6.0dba03f8.jpg";